export default {
  header: "Unser Menü",
  login_for_points: "Login für Punkte",
  table: "Tisch {{id}}",
  buttons: {
    view_order: "Bestellung ansehen",
    continue_to_menu: "Weiter zum Menü",
  },
};
